import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import categoryApi from '../../../api/categories';
import { MORE_SVG } from '../../../assets/icons';
import LoadingContent from '../../../components/LoadingContent';
import NoResults from '../../../components/NoResults';
import { TableBody, TableHeading, TableHeadingCol, TableRow, TableRowItemData } from '../../../components/Table';
import { ICategory, ISubject } from '@wot/typings';
import { Dropdown } from '@wot/components';
import { DropDownItem } from '../../../components/DropDown';

export function Subject() {
  const [subjects, setSubjects] = useState<ICategory<ISubject>[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      setLoading(true);
      categoryApi
        .getCategories('subject')
        .then((data) => {
          if (data) {
            setSubjects(data);
          }
          setLoading(false);
        })
        .catch((err) => err);
    } catch (err) {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <div className="w-full flex items-center justify-between my-4 p-4 bg-[#F4F7FCBF] ">
        <div className="flex items-center gap-4">
          {/* <Search />
          <Filter /> */}
        </div>
        <div className="flex items-center gap-4">
          <Link to="/general-management/categories/addSubject">
            <button className="w-max px-4 py-2 bg-secondary text-white text-sm rounded-full cursor-pointer">
              + Add Subject
            </button>
          </Link>
          {/* <MoreActions /> */}
        </div>
      </div>

      <div className="w-full h-full min-h-[300px] flex flex-col">
        <div className="w-full h-full overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="w-full h-full py-2 inline-block min-w-full sm:px-6 lg:px-8">
            <div className=" w-full h-full overflow-x-auto">
              {loading ? (
                <LoadingContent />
              ) : subjects.length === 0 ? (
                <NoResults />
              ) : (
                <table className="min-w-full table-fixed">
                  <TableHeading>
                    <TableRow>
                      <TableHeadingCol label="#" />
                      <TableHeadingCol label="Date" />
                      <TableHeadingCol label="ID" />
                      <TableHeadingCol label="Name" />
                      <TableHeadingCol label="Grades" />
                      <TableHeadingCol label="" />
                    </TableRow>
                  </TableHeading>
                  <TableBody>
                    {subjects.map((subject, index) => (
                      <TableRow key={subject._id}>
                        <TableRowItemData text={(index + 1).toString()} />
                        <TableRowItemData text={`${dayjs(subject.createdAt).format('DD/MM/YYYY')}`} />
                        <TableRowItemData text={subject._id} />
                        <TableRowItemData text={subject.category.name} />

                        {subject.category.grades && (
                          <TableRowItemData
                            component={
                              <p className="text-sm whitespace-nowrap overflow-hidden">
                                {subject.category.grades.slice(0, 4).toString()}
                                {subject.category.grades.length - 4 > 0 && (
                                  <span className="text-xs p-1 bg-primary text-white mx-2 rounded-md">{`+${
                                    subject.category.grades.length - 4
                                  }more`}</span>
                                )}
                              </p>
                            }
                          />
                        )}
                        <TableRowItemData
                          component={
                            <Dropdown
                              menu={[
                                {
                                  key: 1,
                                  label: <DropDownItem label="Edit" onClick={() => navigate(`${subject._id}`)} />
                                }
                                // {
                                //   key: 2, label: <DropDownItem label="Delete" onClick={() => { }} />
                                // }
                              ]}
                            >
                              <div className="w-full h-full px-4 py-2 flex items-center justify-end cursor-pointer">
                                <img src={MORE_SVG} className="h-4" />
                              </div>
                            </Dropdown>
                          }
                        />
                      </TableRow>
                    ))}
                  </TableBody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
